// Simple Event Bus for in-app pub/sub without external deps
export class EventBus {
  constructor() {
    this.handlers = new Map(); // event -> Set<fn>
  }

  on(event, handler) {
    if (!this.handlers.has(event)) this.handlers.set(event, new Set());
    this.handlers.get(event).add(handler);
    return () => this.off(event, handler);
  }

  off(event, handler) {
    const set = this.handlers.get(event);
    if (!set) return;
    set.delete(handler);
    if (set.size === 0) this.handlers.delete(event);
  }

  emit(event, data) {
    const set = this.handlers.get(event);
    if (!set) {
      if (event === "tableCreated")
        console.warn("🎲 [EventBus] No handlers for tableCreated event!");
      return;
    }
    if (event === "tableCreated" && import.meta?.env?.DEV)
      console.warn(
        "🎲 [EventBus] Emitting tableCreated to",
        set.size,
        "handlers"
      );
    for (const fn of set) {
      try {
        fn(data);
      } catch (e) {
        // isolate handler errors
        console.error("EventBus handler error for", event, e);
      }
    }
  }

  /**
   * Listen to event once and auto-unsubscribe after first call
   * @param {string} event - Event name
   * @param {Function} handler - Handler function
   * @returns {Function} Unsubscribe function
   */
  once(event, handler) {
    const wrapper = (data) => {
      handler(data);
      this.off(event, wrapper);
    };
    return this.on(event, wrapper);
  }
}

export const globalEventBus = new EventBus();
